// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderSummaryRows_container__UOoXQ","rowIcon":"OrderSummaryRows_rowIcon__Myv6x"};